const workerListGridConfig = {
    columns: [
        {
            id: 1,
            width: 275,
            selector: 'documentName',
            name: 'Тип документ',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 2,
            width: 180,
            selector: 'startDate',
            name: 'Валиден от',
            sequenceNumber: 2,
            type: 'date'
        },
        {
            id: 3,
            width: 180,
            selector: 'endDate',
            name: 'Валиден до',
            sequenceNumber: 3,
            type: 'date'
        },
        {
            id: 4,
            width: 225,
            selector: 'egn',
            name: 'ЕГН',
            sequenceNumber: 4,
            type: 'string'
        },
        {
            id: 5,
            width: 225,
            selector: 'firstName',
            name: 'Име',
            sequenceNumber: 5,
            type: 'string'
        },
        {
            id: 6,
            width: 225,
            selector: 'middleName',
            name: 'Презиме',
            sequenceNumber: 6,
            type: 'string'
        },
        {
            id: 7,
            width: 225,
            selector: 'lastName',
            name: 'Фамилия',
            sequenceNumber: 7,
            type: 'string'
        }
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 500,
        filterable: false,
        selectableColumn: {
            show: true,
            icon: 'fa fa-file-alt',
            width: 90
        }
    }
};

export default workerListGridConfig;
